module.exports = __webpack_public_path__ + "resources/img/temp-news-item-1@2x.7209aa5a.png";